import { Flex } from '@chakra-ui/react';
import { FrogBoxLogo } from './frogbox-logo';

export const StepHeader: React.FC = () => {
  return (
    <Flex
      position="fixed"
      top={0}
      left={0}
      right={0}
      justify="flex-end"
      px={4}
      py={3}
      bg="white"
      zIndex={100}
    >
      <FrogBoxLogo size="sm" />
    </Flex>
  );
};
